/**
 * What a contact channel may hold (DVL-010) — the same three expressions, character for character, as the server's
 * `SupportContactChannelRules` (solidus-core); both are tested against
 * `solidus-core/src/test/resources/support/contact-channel-cases.json`. Plain ASCII on purpose: `\s` or a URL parser
 * would mean different things in Java and in JavaScript.
 *
 * - Link: `https://`, exactly the messenger's own host (no user-info, no port), a non-empty path of URL characters
 *   (`%` only as a `%XX` escape). No quotes, spaces or angle brackets — it becomes an `href`.
 * - E-mail: a bare address — RFC 5322 atext minus `? & %` (they would smuggle mailto parameters such as cc or body
 *   into the link), and a dotted domain.
 */

export const MAX_LINK = 255;
export const MAX_EMAIL = 254;

const PATH = "/(?:[A-Za-z0-9\\-._~!$&'()*+,;=:@/?#]|%[0-9A-Fa-f]{2})+$";
const TELEGRAM = new RegExp(`^https://(?:t\\.me|telegram\\.me)${PATH}`, 'i');
const WHATSAPP = new RegExp(`^https://(?:wa\\.me|api\\.whatsapp\\.com)${PATH}`, 'i');
const EMAIL = new RegExp("^[A-Za-z0-9.!#$'*+/=^_`{|}~\\-]+@[A-Za-z0-9\\-]+(?:\\.[A-Za-z0-9\\-]+)+$");

export const isTelegram = (v: string) => v.length <= MAX_LINK && TELEGRAM.test(v);
export const isWhatsapp = (v: string) => v.length <= MAX_LINK && WHATSAPP.test(v);
export const isEmail = (v: string) => v.length <= MAX_EMAIL && EMAIL.test(v);
